import { TemplateResult, html, CSSResultGroup } from 'lit';
import { customElement } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { SlotNGController } from '../../controllers/slot-ng-controller';
import { ResizeController } from '../../controllers/resize-controller';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './tufts-events-schedule.css.lit';

/**
 * Tufts Events Schedule component
 * @element tufts-events-schedule
 * @slot default - The default slot.
 */
@customElement('tufts-events-schedule')
export class tuftsEventsSchedule extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  ngSlot = new SlotNGController(this);
  resizeController: ResizeController = new ResizeController(this);

  render(): TemplateResult {
    const classes = {
      'main-wrapper': true,
      'desktop': this.resizeController.currentBreakpointRange !== 0,
    };
    return html`
      <section class="${classMap(classes)}">
        ${this.ngSlot.renderInShadow()}
      </section>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-events-schedule': tuftsEventsSchedule;
  }
}
